const BASE_URL = import.meta.env.VITE_API_URL ?? 'https://api.theonestack.com';

// Route all fleet API calls through the fleet service prefix so the gateway
// forwards them to fleet-service instead of treating them as unknown services.
function resolveFleetPath(path: string): string {
  return path.replace(/^\/api\//, '/api/fleet/');
}

export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE_URL}${resolveFleetPath(path)}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (res.status === 401) {
    sessionStorage.setItem('returnUrl', window.location.pathname);
    window.location.href = `https://app.theonestack.com/login?redirect=fleet`;
    return new Promise<T>(() => {});
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error ?? `API error: ${res.status}`);
  }

  return res.json();
}
